import React from "react";
import {
  translateService,
  stateService,
  routingService,
  billingService,
  workSpacesService,
  htmlHelperService,
  dateHelperService,
  sessionService,
} from "../../services/imports";
import OptimizedComponent from "../../components/optimizedComponent";
import {
  createValidationContext,
  Input,
  LoadingButton,
  FieldValidation,
} from "../../components/formcontrols/imports";
import { states, stateEvents } from "../../models/states";
import PaymentDetailsPage from "../payment-details/payment-details";
import { Scrollbars } from "react-custom-scrollbars";
// import FacsimileEditor from "./../../components/facsimileEditor";

export default class PackageInfo extends OptimizedComponent {
  constructor() {
    super();

    this.state = {
      email: "",
      workSpaceId: null,
      packages: [],
      userBillings: [],
      billingPackName: null,
      paymentDetails: null,
      isLoading: false,
      addLoading: false,
      nextPayDate: null,
      activeDomain: null,
      roles: [],
      role: "",
      paymentStatus: null,
      oneUser: false,
      billingInfo: null,
      // signatureProcessStep: 1,
      // signatureProcessVisible: false,
      // activeCardIndex: 1,
      // currentLang: translateService.key,
      // facsimData: null,
      // currentFacsimData: null,
      // useFacsimile: 0,
      // faximCardInitialized: false,
    };

    this.emailValidation = createValidationContext();
    this.scrollService = htmlHelperService.createScrollPaging();
  }

  // no member management in an organization's workspace, and none for a
  // corporate (hrms) account, whose workspaces are all its organizations'
  // (the backend refuses: error.organizationWorkspaceMembers)
  membersManaged = () =>
    !sessionService.isCorporate() && !sessionService.organizationOf(this.state.workSpaceId);

  addUserToWorkSpace = () => {
    let valid = this.emailValidation.removeCustomErrors().setDirty().isValid();
    if (!valid) {
      stateService.event(stateEvents.validateCheck, { check: true });
      return;
    }
    this.setState({ addLoading: true });
    workSpacesService
      .addUserToWorkSpace(this.state.workSpaceId, this.state.email, this.state.role)
      .subscribe(
        (res) => {
          this.setState({
            email: "",
            userBillings: [res.data, ...this.state.userBillings],
          });
          this.emailValidation.dirty = false;
          this.setState({ addLoading: false });
        },
        () => {
          this.setState({ addLoading: false });
        }
      );
  };

  goBack = () => {
    if (this.props?.match?.fromRoute) {
      routingService.navigate(routingService.routes.default);
    } else {
      if (this.props?.shouldReload) {
        document.location.reload();
      } else {
        stateService.event(stateEvents.openModalPage, null);
      }
    }
  };

  viewPackage = (id) => {
    this.setState({ paymentDetails: id });
  };

  updateErrorInfo = (e) => {
    !e.target.value && e.target.classList.add("tooltip-error");
  };

  copyText = (text) => {
    htmlHelperService.copyToClipboard(text);
  };

  closeModal = () => {
    this.setState({ paymentDetails: null });
  };

  deleteUserFromWorkSpace = (e, userId, workspaceID) => {
    e.stopPropagation();
    workSpacesService
      .deleteUserFromWorkSpace(userId, workspaceID)
      .subscribe(() => {
        this.setState((prevState) => ({
          userBillings: prevState.userBillings.filter(
            (user) => user.userId !== userId
          ),
        }));
      });
  };

  getUserBillings = () => {
    this.secureSubscription(
      billingService.getUserBillingPackages().subscribe((res) => {
        if (!res.data) return;

        this.setState({
          billingInfo: res.data.billingInfo,
          billingPackName: res.data.billingPackName,
          nextPayDate: res.data.nextPayDate,
          oneUser: res.data.oneUser,
          // the main workspace, by its exposed id (members, add, organizationOf)
          workSpaceId: res.data.workspaceExposedId,
          activeDomain: res.data.domainName,
        });
        // the package's workspace comes from the billing info (no v2 yet);
        // an organization's members are Keycloak's, not listed here
        if (res.data.workspaceExposedId && !sessionService.isCorporate() && !sessionService.organizationOf(res.data.workspaceExposedId))
          this.getWorkSpaceUsers(res.data.workspaceExposedId);
      })
    );
  };

  // infinite scroll over the cursor pages (pageInfo.next, null at the end);
  // pages are appended without duplicates (a member added here is already
  // at the top when the last page brings it again)
  getWorkSpaceUsers = (workSpaceId) => {
    if (this.usersLoading || this.usersFinished) return;
    this.usersLoading = true;
    this.secureSubscription(
      workSpacesService.getWorkSpaceUsers(workSpaceId, this.usersCursor).subscribe(
        (res) => {
          this.usersLoading = false;
          const page = res.data || {};
          this.usersCursor = page.pageInfo && page.pageInfo.next;
          this.usersFinished = !this.usersCursor;
          this.setState(
            (state) => {
              const known = new Set(state.userBillings.map((u) => u.id));
              const fresh = (page.userList || []).filter((u) => !known.has(u.id));
              return { userBillings: [...state.userBillings, ...fresh] };
            },
            // fill the list until it scrolls
            () => {
              const list = this.usersList && this.usersList.container.firstChild;
              if (!this.scrollService.hasScollHeight(list)) this.getWorkSpaceUsers(workSpaceId);
            }
          );
        },
        () => {
          this.usersLoading = false;
        }
      )
    );
  };

  scrollUsers = (e) => {
    if (this.usersLoading || !this.state.workSpaceId) return;
    this.scrollService.onScrollDown(e, () => this.getWorkSpaceUsers(this.state.workSpaceId));
  };

  getRoles = () => {
    this.secureSubscription(
      workSpacesService.getRoles().subscribe((res) => {
        const roles = res.data || [];
        this.setState({ roles, role: roles.length ? roles[0].key : "" });
      })
    );
  };

  componentDidMount() {
    this.secureSubscription(
      translateService.subscribe((_) => {
        this.setState({ currentLang: translateService.key });
      })
    );

    this.secureSubscription(
      stateService.getState(states.userInfo).subscribe((data) => {
        this.setState({
          nextPayDate: data?.nextPayDate,
          paymentStatus: data?.paymentStatus,
          // useFacsimile: data.useFacsimile,
          // currentFacsimData: data.facsimilePath
        });
      })
    );

    this.secureSubscription(
      billingService.getBillingPackages().subscribe((res) => {
        this.setState({ packages: res.data });
      })
    );

    this.getRoles();
    this.getUserBillings();

    if (this.props?.match?.params.packetid) {
      const bogData = {
        id: this.props.match.params.packetid,
        value: "BOG",
      };

      this.secureSubscription(
        billingService.authorizeBOG(bogData).subscribe((res) => {
          if (res.success && res.data) {
            document.location.href = res.data;
          }
        })
      );
    }
  }

  /* facsimile */
  // setActivefacsimData = (data, index) => {
  //   this.setState({ activeCardIndex: index, facsimData: data });
  // };

  // validateWithoutApostile = () => {
  //   this.endSugnatureProcess();
  // };

  // startSignatureEditing = () => {
  //   this.setState({ signatureProcessVisible: true });

  //   htmlHelperService
  //     .setIdleTimer(800)
  //     .subscribe(() => {
  //       this.setState({ faximCardInitialized: true });
  //     })
  //     .unsubscribe();
  // };

  // endSugnatureProcess = () => {
  //   this.setState({ signatureProcessVisible: false });
  // };

  // sendFacsimData = (_) => {
  //   this.setState(
  //     (prevState) => {
  //       prevState.useFacsimile = prevState.useFacsimile + 1;
  //       return prevState;
  //     },
  //     () => {
  //       this.endSugnatureProcess();
  //     }
  //   );

  //   const user = stateService.getState(states.userInfo).value;
  //   const userData = { ...user };
  //   userData.facsimilePath = this.state.facsimData;
  //   stateService.setState(states.userInfo, userData);
  // };

  // resetFacsimileStates = () => {
  //   this.setState({
  //     activeCardIndex: 1,
  //     facsimData: null,
  //   });
  // };

  render() {
    return (
      <React.Fragment>
        {this.state.paymentDetails ? (
          <PaymentDetailsPage
            packageId={this.state.paymentDetails}
            activeDomain={this.state.activeDomain}
            onCloseModal={this.closeModal}
          />
        ) : (
          <div
            className={`package-info container ${translateService.key} ${
              !this.props?.display ? "d-none" : ""
            }`}
          >
            <div className="page-header">
              <span className="clickable" onClick={this.goBack}>
                <img src="../../assets/images/close32.svg" />
              </span>
            </div>
            <div className="package-info-items">
              <div className="flex-title-item">
                <div className="title-container">
                  <span className="title">
                    {translateService.t("payments.detailPageTitle")}
                  </span>
                  {/* {this.state.useFacsimile > 0 && (
                    <span
                      className="facsimileChangeButton"
                      onClick={this.startSignatureEditing}
                    >
                      {translateService.t("common.changeFacsimile")}
                    </span>
                  )} */}
                  {/* {translateService.t("payments.detailPageTitle1")} */}
                </div>
                {/* package_name, next pay date 22/11/2022 (billing info) */}
                <div className="accinfoF">
                  <span className="account-info">
                    <div className="ai">
                      <span className="account-number">
                        {this.state.activeDomain}
                      </span>
                      <span className="account-domain-name">
                        {translateService.t("common.accountDomainName")}
                      </span>
                    </div>
                    {/* {this.state.nextPayDate && (
                      <div className="nd">
                        <span>
                          {translateService.t("common.nextPayDateTitle")}{" "}
                        </span>
                        <span>
                          {dateHelperService.format(
                            this.state.nextPayDate,
                            dateHelperService.serverDateFormat,
                            false,
                            true
                          )}
                        </span>
                      </div>
                    )} */}
                  </span>
                </div>
              </div>

              <span className="title2">
                {translateService.t("payments.detailPageTitle2")}
                <span className="color-two mx-768">
                &nbsp;
                  {
                  // this.state.paymentStatus === 0
                  //   ? <span>{translateService.t("packages.freePackage")}</span>
                  //   : 
                    <span>{this.state.billingPackName || ""}</span>}
                  {this.state.nextPayDate && (
                    <>
                      ,&nbsp;
                      <span className="nd color-black">
                        <span>
                          {translateService.t("common.nextPayDateTitle")}{" "}
                        </span>
                        <span className="color-two">
                          {dateHelperService.format(
                            this.state.nextPayDate,
                            dateHelperService.serverDateFormat,
                            false,
                            true
                          )}
                        </span>
                      </span>
                    </>
                  )}{" "}
                  {this.state.billingInfo && (
                    <>,&nbsp;
                      <span className="color-black">
                        {this.state.billingInfo}
                      </span>
                    </>
                  )}
                </span>
                <div className="userWorkspace">
                  {translateService.t("packages.userWorkspace")}
                </div>
              </span>

              <div className="items">
                {!this.membersManaged() ? (
                <div className="item">
                  <p className="organization-members-note">
                    {translateService.t("organization.membersInKeycloak")}
                  </p>
                </div>
                ) : (
                <div className="item">
                  <div className="inputs-container">
                    <div className="input-item">
                      <Input
                        name="email"
                        type="email"
                        placeholder={translateService.t(
                          "payments.adduserEmail"
                        )}
                        autoComplete="off"
                        spellCheck="false"
                        maxLength="50"
                        value={this.state.email || ""}
                        onChange={(e) => {
                          this.setState({
                            email: e.target.value,
                          });
                        }}
                        rules={[{ name: "email", convert: { trim: true } }]}
                        validation={this.emailValidation}
                        ref={(input) => (this.user_email = input)}
                        onFocus={(e) => this.updateErrorInfo(e)}
                      />

                      <FieldValidation
                        name="email"
                        className="validation-register"
                        rule="email"
                        validation={this.emailValidation}
                        for={this.user_email}
                      />
                    </div>
                    <div className="input-item">
                      <select
                        name="role"
                        className="role-select"
                        value={this.state.role}
                        onChange={(e) => this.setState({ role: e.target.value })}
                      >
                        {this.state.roles.map((r) => (
                          <option key={r.id} value={r.key}>
                            {r.value || r.key}
                          </option>
                        ))}
                      </select>
                    </div>
                    <div className="buttons">
                      <LoadingButton
                        className="button background-color-two color-white"
                        loading={this.state.addLoading}
                        onClick={this.addUserToWorkSpace}
                        disabled={this.state.oneUser}
                      >
                        {translateService.t(`common.add`)}
                      </LoadingButton>
                    </div>
                  </div>
                  <div className="listContainer">
                    <div className="listHeader">
                      {translateService.t("payments.listOfPaymentUsers")}{" "}
                      <span className="btn clickable">
                        {translateService.t("common.delete")}
                      </span>
                    </div>
                    <Scrollbars
                      onScroll={this.scrollUsers}
                      ref={(el) => (this.usersList = el)}
                      autoHide
                      className="listScrollbar"
                    >
                      {this.state.userBillings.map((user, index) => (
                        <React.Fragment key={user.id + index}>
                          <div
                            className={`listItem hover ${
                              index % 2 == 0 ? "" : "white-bg"
                            }`}
                          >
                            {user.username}
                            <img
                              className="clickable"
                              src="../../assets/images/close32.svg"
                              onClick={(e) =>
                                this.deleteUserFromWorkSpace(
                                  e,
                                  user.userId,
                                  user.workspaceExposedId
                                )
                              }
                            />
                          </div>
                        </React.Fragment>
                      ))}
                    </Scrollbars>
                  </div>
                </div>
                )}

                <div className="item">
                  <div className="packages-list">
                    <span className="title">
                      {translateService.t("payments.packageChangeTitle")}{" "}
                    </span>

                    <div className="packages-list-items">
                      {this.state.packages.map((p) => (
                        <div className="packages-item" key={p.id}>
                          <div className="packages-item-detail">
                            <span className="package-title">{p.key}</span>
                            <span className="package-desc">
                              {p.description}
                            </span>
                            <span className="package-amount">{p.value}</span>
                          </div>
                          {/* <div className="pachage-item-buy">
                                                <div className="buttons" >
                                                    <LoadingButton
                                                        className="button background-color-two color-white"
                                                        loading={this.state.isLoading}
                                                        onClick={() => this.viewPackage(0)}
                                                    >
                                                        {translateService.t(`packages.buy`)}
                                                    </LoadingButton>
                                                </div>
                                            </div> */}
                        </div>
                      ))}
                      <div className="packages-item bog">
                        <div className="packages-item-detail">
                          <span className="package-title">
                            {translateService.t("common.transferToBank")}
                          </span>
                          <span className="package-nomination">
                            {translateService.t("common.accountNumber")}
                          </span>
                          <span className="package-desc">
                            {globalConfig.AccountNumber}
                          </span>
                          <span className="package-comment">
                            {translateService.t("common.nomination")}
                          </span>
                        </div>
                        <div className="pachage-item-buy">
                          <div className="buttons">
                            <LoadingButton
                              className="button background-color-one color-white"
                              onClick={() =>
                                this.copyText(globalConfig.AccountNumber)
                              }
                            >
                              {translateService.t(`common.copy`)}
                            </LoadingButton>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
        {/* <FacsimileEditor
          isEditing={true}
          isVisible={this.state.signatureProcessVisible}
          onClosed={this.resetFacsimileStates}
          onToggle={this.endSugnatureProcess}
          signatureProcessStep={this.state.signatureProcessStep}
          faximCardInitialized={this.state.faximCardInitialized}
          currentLang={this.state.currentLang}
          sendFacsimData={this.sendFacsimData}
          onSetFacsimData={this.setActivefacsimData}
          activeCardIndex={this.state.activeCardIndex}
          facsimData={this.state.facsimData}
          currentFacsimData={this.state.currentFacsimData}
        /> */}
      </React.Fragment>
    );
  }
}
